import {
    FETCH_ACTIVE_PROJECT_LIST,
    FETCH_ACTIVE_PROJECT_MEMBER_LIST,
    FETCH_ACTIVE_PROJECT_AVAILABLE_MEMBER_LIST,
    ADD_MEMBER_TO_ACTIVE_PROJECT,
    REMOVE_MEMBER_FROM_ACTIVE_PROJECT,
    UPDATE_SELECTED_PROJECT,
    UPDATE_ACTIVE_PROJECT_MEMBER_AUTH,
    UPDATE_PREVIEW_PANEL_INFO,
    UPDATE_LOCATION_LIST,
    UPDATE_ESTATE_LIST
} from '../ActionTypes'

const API_URL = process.env.API_URL

// FETCH Estate List
const requestEstateList = () => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: []
    }
}

const receiveEstateList = (array) => {
    return {
        type: UPDATE_ESTATE_LIST,
        payload: array
    }
}

export const fetchEstateList = (token) => {
    return dispatch => {
        dispatch(requestEstateList())
        return fetch(`${API_URL}/suggest/estate`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveEstateList(json.result)))
    }
}

// FETCH Location List
const requestLocationList = () => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: []
    }
}

const receiveLocationList = (array) => {
    return {
        type: UPDATE_LOCATION_LIST,
        payload: array
    }
}

export const fetchLocationList = (token) => {
    return dispatch => {
        dispatch(requestLocationList())
        return fetch(`${API_URL}/suggest/location`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receiveLocationList(json.result)))
    }
}

// FETCH Active Project List
const requestActiveProjectList = () => {
    return {
        type: FETCH_ACTIVE_PROJECT_LIST,
        payload: []
    }
}

const receiveActiveProjectList = (array) => {
    return {
        type: FETCH_ACTIVE_PROJECT_LIST,
        payload: array
    }
}

export const fetchActiveProjectList = (token, status) => {
    return dispatch => {
        dispatch(requestActiveProjectList())
        return fetch(`${API_URL}/project?status=${status}`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveActiveProjectList(json.result))
            })
    }
}

export const refetchActiveProjectList = (token, status) => {
        return dispatch => {
            return fetch(`${API_URL}/project?status=${status}`, {
                    mode: 'cors',
                    headers: {
                        'Authorization': `bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(json => {
                    dispatch(receiveActiveProjectList(json.result))
                })
        }
    }
    // export const clearProjectSelection = () => {
    //     return {
    //         type: SELECT_ACTIVE_PROJECT,
    //         payload: null
    //     }
    // }

// // SELECT Active Porject
// export const selectActiveProject = (projectIdx) => {
//     return {
//         type: SELECT_ACTIVE_PROJECT,
//         payload: projectIdx
//     }
// }

// FETCH Active Project Member List
const requestActiveProjectMemberList = () => {
    return {
        type: FETCH_ACTIVE_PROJECT_MEMBER_LIST,
        payload: {}
    }
}

const receiveActiveProjectMemberList = (json) => {
    return {
        type: FETCH_ACTIVE_PROJECT_MEMBER_LIST,
        payload: json
    }
}

export const fetchActiveProjectMemberList = (token, projectId) => {
    return dispatch => {
        dispatch(requestActiveProjectMemberList())
        return fetch(`${API_URL}/project/${projectId}/member`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveActiveProjectMemberList(json.result))
            })
    }
}

// FETCH Active Project Available Member List
const requestActiveProjectAvailableMemberList = () => {
    return {
        type: FETCH_ACTIVE_PROJECT_AVAILABLE_MEMBER_LIST,
        payload: []
    }
}

const receiveActiveProjectAvailableMemberList = (json) => {
    return {
        type: FETCH_ACTIVE_PROJECT_AVAILABLE_MEMBER_LIST,
        payload: json
    }
}

export const fetchActiveProjectAvailableMemberList = (token, projectId) => {
    return dispatch => {
        dispatch(requestActiveProjectAvailableMemberList())
        return fetch(`${API_URL}/project/${projectId}/member/available`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                dispatch(receiveActiveProjectAvailableMemberList(json.result))
            })
    }
}

// ADD member to project
const requestAddMemberToActiveProject = () => {
    return {
        type: ADD_MEMBER_TO_ACTIVE_PROJECT,
        payload: true
    }
}

const receiveAddMemberToActiveProjectResult = () => {
    return {
        type: ADD_MEMBER_TO_ACTIVE_PROJECT,
        payload: false
    }
}

export const addMemberToActiveProject = (token, projectId, memberId) => {
    return dispatch => {
        dispatch(requestAddMemberToActiveProject())
        return fetch(`${API_URL}/project/${projectId}/member/add`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ memberId })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveAddMemberToActiveProjectResult()))
    }
}

// REMOVE member to project
const requestRemoveMemberFromActiveProject = () => {
    return {
        type: REMOVE_MEMBER_FROM_ACTIVE_PROJECT,
        payload: true
    }
}

const receiveRemoveMemberFromActiveProjectResult = () => {
    return {
        type: REMOVE_MEMBER_FROM_ACTIVE_PROJECT,
        payload: false
    }
}

export const removeMemberFromActiveProject = (token, projectId, memberId) => {
    return dispatch => {
        dispatch(requestRemoveMemberFromActiveProject())
        return fetch(`${API_URL}/project/${projectId}/member/remove`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ memberId })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveRemoveMemberFromActiveProjectResult()))
    }
}

// UPDATE member auth in project
const requestUpdateActiveProjectMemberAuth = () => {
    return {
        type: UPDATE_ACTIVE_PROJECT_MEMBER_AUTH,
        payload: true
    }
}

const receiveUpdateActiveProjectMemberAuthResult = () => {
    return {
        type: UPDATE_ACTIVE_PROJECT_MEMBER_AUTH,
        payload: false
    }
}

export const updateActiveProjectMemberAuth = (token, projectId, memberId, isAuthorized) => {
    return dispatch => {
        dispatch(requestUpdateActiveProjectMemberAuth())
        return fetch(`${API_URL}/project/${projectId}/member/auth`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ memberId, isAuthorized })
            })
            .then(response => response.json())
            .then(json => dispatch(receiveUpdateActiveProjectMemberAuthResult()))
    }
}

// UPDATE payment status of active project
export const updateActiveProjectDocumentPaymentStatus = (token, projectId, documentId, paymentIdx, paid, paidAt, projectStatus) => {
    return dispatch => {
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}/payment`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ paymentIdx, paid, paidAt })
            })
            .then(response => response.json())
            .then(json => dispatch(refetchActiveProjectList(token, projectStatus)))
    }
}

// UPDATE invoice status of active project
export const updateActiveProjectDocumentInvoiceStatus = (token, projectId, documentId, paymentIdx, sent, projectStatus) => {
    return dispatch => {
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}/invoice`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ paymentIdx, sent })
            })
            .then(response => response.json())
            .then(json => dispatch(refetchActiveProjectList(token, projectStatus)))
    }
}

// Fetch preview panel data
const requestPreviewPanelResult = () => {
    return {
        type: UPDATE_PREVIEW_PANEL_INFO,
        payload: {}
    }
}

const receivePreviewPanelResult = (json) => {
    return {
        type: UPDATE_PREVIEW_PANEL_INFO,
        payload: json
    }
}

export const fetchProjectPreviewPanelInfo = (token, projectId) => {
    return dispatch => {
        dispatch(requestPreviewPanelResult())
        return fetch(`${API_URL}/project/${projectId}/preview-panel`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receivePreviewPanelResult(json.result)))
    }
}

export const fetchDocumentPreviewPanelInfo = (token, projectId, documentId) => {
    return dispatch => {
        dispatch(requestPreviewPanelResult())
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}/preview-panel`, {
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => dispatch(receivePreviewPanelResult(json.result)))
    }
}

// Update Custom Alert of Project
export const updateProjectCustomAlert = (token, projectId, customAlertContent, customAlertDue) => {
    return dispatch => {
        return fetch(`${API_URL}/project/${projectId}/custom-alert`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    content: customAlertContent,
                    due: customAlertDue
                })
            })
            .then(response => response.json())
            .then(json => dispatch(fetchProjectPreviewPanelInfo(token, projectId)))
    }
}

export const updateDocumentCustomAlert = (token, projectId, documentId, customAlertContent) => {
    return dispatch => {
        return fetch(`${API_URL}/project/${projectId}/document/${documentId}/custom-alert`, {
                method: 'PUT',
                mode: 'cors',
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    description: customAlertContent,
                })
            })
            .then(response => response.json())
            .then(json => dispatch(fetchDocumentPreviewPanelInfo(token, projectId, documentId)))
    }
}

///////////////

export const updateSelectedProject = (project) => {
    return {
        type: UPDATE_SELECTED_PROJECT,
        payload: project
    }
}



// WEBPACK FOOTER //
// ./src/ActiveProjectPage/ActiveProjectPageActions.js